import { breadcrumbScript } from "@/lib/seo-jsonld";
import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck, Users, Zap } from "lucide-react";

export const Route = createFileRoute("/haqqimizda")({
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { title: "Haqqımızda — Albazar.az" },
      { name: "description", content: "Albazar.az Azərbaycanın müasir elan platformasıdır. Missiyamız və komandamız haqqında." },
      { property: "og:title", content: "Haqqımızda — Albazar.az" },
      { property: "og:description", content: "Albazar.az platforması haqqında." },
    
      { property: "og:url", content: "https://albazar.az/haqqimizda" },
    ],
    links: [{ rel: "canonical", href: "https://albazar.az/haqqimizda" }],
    scripts: [breadcrumbScript([{ name: "Haqqımızda", path: "/haqqimizda" }])],
  }),
  component: () => (
    <div className="container-x max-w-3xl py-12">
      <h1 className="text-4xl font-extrabold tracking-tight">Haqqımızda</h1>
      <p className="mt-4 leading-relaxed text-muted-foreground">
        Albazar.az — Azərbaycanda al-sat prosesini sadələşdirən müasir elan platformasıdır. 2026-cı ildən
        etibarən minlərlə istifadəçi hər gün platformamız vasitəsilə ev, avtomobil, texnika, geyim və
        xidmətlər alır və satır.
      </p>
      <p className="mt-4 leading-relaxed text-muted-foreground">
        Məqsədimiz alıcı və satıcını ən sürətli, təhlükəsiz və rahat şəkildə bir araya gətirməkdir.
        Bütün elanlar moderasiyadan keçir, şübhəli elanlar dərhal silinir.
      </p>
      <div className="mt-10 grid gap-4 sm:grid-cols-3">
        {[
          { icon: Users, title: "18 000+ istifadəçi", desc: "Aktiv alıcı və satıcı bazası" },
          { icon: Zap, title: "42 000+ elan", desc: "Bütün kateqoriyalar üzrə" },
          { icon: ShieldCheck, title: "Təhlükəsiz", desc: "Hər elan moderasiyadan keçir" },
        ].map((c) => (
          <div key={c.title} className="animate-pop rounded-3xl border border-border bg-card p-6 shadow-card">
            <c.icon className="size-6 text-primary" />
            <p className="mt-3 font-bold">{c.title}</p>
            <p className="text-sm text-muted-foreground">{c.desc}</p>
          </div>
        ))}
      </div>
    </div>
  ),
});